"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var Locale_1 = require("../../../Locale");
function cls(arr) {
  return arr.filter(function (item) {
    return typeof item === 'string';
  }).join(' ');
}
function FilterMenuL1(props) {
  var cat = props.cat,
    updateCat = props.updateCat,
    _a = props.mobile,
    mobile = _a === void 0 ? false : _a;
  var categories = reconnect_js_1.useOutlet(props.categories)[0];
  return react_1.default.createElement(Wrapper, {
    className: cls(['rev-FilterMenuL1', mobile && 'mobile'])
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("div", {
    className: "label",
    onClick: function onClick() {
      return updateCat('');
    }
  }, "\u7522\u54C1\u5206\u985E")), categories.map(function (catL1) {
    return react_1.default.createElement(TopLevelCategory, {
      key: catL1.name,
      catL1: catL1,
      cat: cat,
      updateCat: updateCat
    });
  }));
}
exports.default = FilterMenuL1;
function TopLevelCategory(props) {
  var catL1 = props.catL1,
    cat = props.cat,
    updateCat = props.updateCat;
  var currL1 = (cat || '').split('-')[0];
  var selected = currL1 === catL1.name;
  return react_1.default.createElement(CatL1Wrapper, {
    className: cls(['L1', selected && 'selected'])
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("div", {
    className: "label",
    onClick: function onClick() {
      return updateCat(catL1.name);
    }
  }, Locale_1.F(catL1, 'display') || catL1.name)));
}
var CatL1Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 12px;\n  padding: 10px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n\n  &.selected {\n    background-color: #aaa;\n\n    & > .header {\n      color: white;\n    }\n  }\n\n  & > .header {\n    display: flex;\n    align-items: center;\n    font-size: 1.2rem;\n    color: #888;\n\n    & > .label {\n      flex: 1;\n      cursor: pointer;\n      line-height: 40px;\n      text-align: center;\n    }\n  }\n"], ["\n  border-radius: 12px;\n  padding: 10px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n\n  &.selected {\n    background-color: #aaa;\n\n    & > .header {\n      color: white;\n    }\n  }\n\n  & > .header {\n    display: flex;\n    align-items: center;\n    font-size: 1.2rem;\n    color: #888;\n\n    & > .label {\n      flex: 1;\n      cursor: pointer;\n      line-height: 40px;\n      text-align: center;\n    }\n  }\n"])));
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 200px;\n\n  position: sticky;\n  top: var(--topNavBarHeight);\n\n  & > .header {\n    padding: 15px 10px;\n    display: flex;\n    align-items: center;\n\n    & > .label {\n      flex: 1;\n      font-size: 1.3rem;\n      cursor: pointer;\n      text-align: center;\n    }\n  }\n\n  &.mobile {\n    padding: 0 8px;\n  }\n"], ["\n  width: 200px;\n\n  position: sticky;\n  top: var(--topNavBarHeight);\n\n  & > .header {\n    padding: 15px 10px;\n    display: flex;\n    align-items: center;\n\n    & > .label {\n      flex: 1;\n      font-size: 1.3rem;\n      cursor: pointer;\n      text-align: center;\n    }\n  }\n\n  &.mobile {\n    padding: 0 8px;\n  }\n"])));
var templateObject_1, templateObject_2;